module.exports = __webpack_public_path__ + "img/zhengshu4.66eba367.jpg";